import url from 'url';
export function parseQuery(uriOrPath) {
    var pageUrl = uriOrPath.startsWith('http') ? uriOrPath : "http://fake.host" + uriOrPath;
    return url.parse(pageUrl, true).query;
}
export function deleteFromRequireCache(request) {
    var _a;
    var mod = require.cache[request];
    var parentChildren = (_a = mod === null || mod === void 0 ? void 0 : mod.parent) === null || _a === void 0 ? void 0 : _a.children;
    // Only delete from require.cache will cause memory leak, because the module is also
    // referenced in parent module.
    if (parentChildren) {
        parentChildren.forEach(function (child, index) {
            if (child.id === (mod === null || mod === void 0 ? void 0 : mod.id)) {
                parentChildren.splice(index, 1);
            }
        });
    }
    delete require.cache[request];
}
